<template>
  <div class="home">
    <!-- 首图banner -->
    <div class="home-swipe">
      <van-swipe :autoplay='3000' :height='150' lazy-render>
        <van-swipe-item class="home-swipe__item" v-for='(image, index) in bannerImgList' :key='index'>
          <van-image :height="150" :src='image' fit="contain"/>
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- Grid项目 -->
    <div class='grid-block'>
      <van-grid :column-num='gridClassList.length'>
        <van-grid-item
          v-for="item in gridClassList"
          :key="item.id" 
          :icon='item.coverPic'
          :text="item.category"
          :to="`/goods?categoryId=${item.id}`"
        />
      </van-grid> 
    </div>
    <!-- 一个推荐模块 -->
    <div class='rec-wrapper'>
      <cell-card
        title='大牌咖啡'
      >
        <!-- swipe产品框 -->
        <div class='rec-item__goods-block'>
          <div class='rec-item__goods-wrapper'>
            <div 
              class='rec-item__goods-item'
              v-for="item in hotToday"
              :key='item.id'
              @click="onGoToSku(item.skuCode)"
            >  
              <van-row
                class='rec-item__goods-item-avatar-wrapper'
              >
                <van-image
                  height="8rem"
                  fit="cover"
                  round
                  :src="item.coverPic "
                />
              </van-row>
              <van-row
                class='rec-item__goods-item-title-wrapper'
              >
                <div class='van-ellipsis rec-item__goods-item-title'>{{item.skuName}}</div>
              </van-row>
              <van-row
                class="rec-item__goods-item-price-wrapper"
                type="flex"
                align="bottom"
              >
                <van-col class='rec-item__goods-item-disc-price'>¥ {{fen2Yuan(item.discPrice)}}</van-col> 
                <van-col class='rec-item__goods-item-market-price'>原价 ¥ {{fen2Yuan(item.rawPrice)}}</van-col>
              </van-row>
            </div>
          </div>
        </div>
      <!-- </div> -->
      </cell-card>
    </div>
    <!-- 底线 -->
    <van-divider
      class='home-bottom__bottom-line'
    >
      我是有底线的
    </van-divider>
  </div>
</template>

<script>
// @ is an alias to /src
import {Swipe, SwipeItem, Grid, GridItem, Col, Row, Image, Divider} from "vant";
import CellCard from "@/components/CellCard.vue";
import request from "@/utils/request.js";

export default {
  name: 'Home',
  // 局部注册组件
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Col.name]: Col,
    [Row.name]: Row,
    [Image.name]: Image,
    [CellCard.name]: CellCard,
    [Divider.name]: Divider
  },
  data() {
    return {
      gridClassList: [],
      bannerImgList: [],
      hotToday: []
    };
  },
  mounted() {
    this.loadHomeInfo();
  },
  methods: {
    onGridClick(e) {
      console.log(e);
    },
    onGoToSku(skuCode) {
      this.$router.push(`/sku/${skuCode}`);
    }, 
    async loadHomeInfo() {
      const {data} = await request.get("/customer/home/homeInfo");
      this.hotToday = data.hotToday;
      this.bannerImgList = data.bannerImgList;
      this.gridClassList = data.goodsCategoryList;
    },
    fen2Yuan(fen) {
      return (fen / 100).toFixed(2);
    }
  }
}
</script>

<style lang='less'>
@import '@/style/base.less';
.home {
 
  .home-swipe {
    padding: 8px;

    .van-swipe {
      border-radius: 8px;
      overflow: hidden;
    }
  }

  .home-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    text-align: center;
  }

  .grid-block {

    padding: 0 8px;

    .van-grid {
      border-radius: 8px;
      overflow: hidden;
    }
  }

  .rec-item__goods-block {
    width: 100%;
    overflow-y: hidden;
    padding: 0 0 8px 0;
  }

  .rec-item__goods-wrapper {
    display: inline-block;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
  }

  .rec-item__goods-item {
    display: inline-block;
    white-space: nowrap;
    width: 10rem;
    margin: 0 8px;
  }

  .rec-item__goods-item-disc-price {
    color: @color-theme;
    font-weight: @font-weight-title;
    line-height: @line-height-title;
    word-spacing: normal;
  }

  .rec-item__goods-item-market-price {
    color: @font-color-secondary;
    font-size: @font-size-mini;
    line-height: @line-height-mini;
    font-weight: @font-weight-normal;
    text-decoration: line-through;
    vertical-align: bottom;
    word-spacing: normal;
    padding-left: 8px;
  }

  .home-bottom__bottom-line {
    color: @font-color-secondary;
    border-color: @color-divider;
    padding: 0 16px;
  }
}
</style>
